import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { materialModules } from '../angular-material.module';
import { getPaginatorIntl } from '../_core/services/localization.service';

import { SelectDialogComponent } from './components/select-dialog/select-dialog.component';
import { DisclaimerDialogComponent } from './components/disclaimer-dialog/disclaimer-dialog.component';
import { NewsPopupDialogComponent } from './components/news-popup-dialog/news-popup-dialog.component';
import { AssetMediaComponent } from './components/asset-media/asset-media.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { MarkDownPipe } from './pipes/markdown.pipe';
import { LocalVarDirective } from './directives/local-var.directive';
import { TextSingularPluralPipe } from './pipes/text-singular-plural.pipe';

/**
 * SharedCoreModule — the minimal set of shared declarations that the eager app
 * shell (AppModule + FooterComponent) actually references at boot.
 *
 * Keep this module lean: do NOT add a declaration here unless eager
 * code (a root-scoped service, interceptor, guard, or the app shell) references
 * it.
 *
 * See SharedModule, which re-exports this module so lazy consumers are
 * unaffected.
 */
const CORE_DECLARATIONS = [
	SelectDialogComponent,
	DisclaimerDialogComponent,
	NewsPopupDialogComponent,
	AssetMediaComponent,
	SafeHtmlPipe,
	MarkDownPipe,
	LocalVarDirective
];

@NgModule({
	imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, ...materialModules],
	declarations: CORE_DECLARATIONS,
	providers: [
		// Root-provided services inject the pipes as a service
		DatePipe,
		TextSingularPluralPipe,
		{ provide: MatPaginatorIntl, useFactory: getPaginatorIntl }
	],
	exports: CORE_DECLARATIONS
})
export class SharedCoreModule {}
